<template>
  <main-header />
  <el-main>
    <div class="main-sidebar">
      <el-affix v-if="isUsingMainSidebar()" :offset="60">
        <main-sidebar>Aside</main-sidebar>
      </el-affix>
    </div>
    <div class="main-content">
      <breadcrumb v-if="isLoggedin && route.path == '/documentation'" />
      <div class="main-content__focus">
        <router-view v-slot="{ Component, route }">
          <component :is="Component" :key="route.path" />
        </router-view>
      </div>
    </div>
  </el-main>
</template>

<script setup>
import MainHeader from '@/components/layout/MainHeader'
import MainSidebar from '@/components/layout/MainSidebar'
import Breadcrumb from '@/components/layout/Breadcrumb'
import { computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'

const route = useRoute()
const store = useStore()
const dataListUsingMainSidebar = [
  'documentation',
  'console',
  'privacy-policy'
]
const isLoggedin = computed(() => {
  return store.getters['app/isLoggedin']
})
onMounted(() => {
  isUsingMainSidebar()
})
const isUsingMainSidebar = () => {
  const url = route.path.split('/')
  const exist = dataListUsingMainSidebar.find(element => element === url[1])
  if (exist) {
    return true
  } else {
    return false
  }
}
</script>
